'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/configurator'));
    processInclude(require('./product/finance'));
    processInclude(require('./product/navigation').navigation);
});
